import { Injectable } from '@angular/core'; //permite definir los servicios e inyectarlos en cauqluier otra clase
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http'; //para enviar cabezeras en las peticiones ajax
import { Observable } from 'rxjs/Observable'; //recoger las respuestas que nos devuelve el API
import { GLOBAL } from './global'; // la url del API
import { Terminal } from '../models/terminal';

@Injectable()
export class TerminalService{

    public url:string; //url de nuestro backend

    constructor(public _http:HttpClient){
        this.url = GLOBAL.url;
    }

    /* CATALOGO */

    GRIDlistarTerminales(token:string): Observable<any>{
        let headers = new HttpHeaders().set('Content-Type','application/json')
                                       .set('Authorization',token);

        return this._http.get(this.url+'GRID-listar-terminal', {headers:headers});
    }

    /* FUNCIONES */

    obtenerTerminalPorSucursal(token:string): Observable<any>{
        let headers = new HttpHeaders().set('Content-Type','application/json')
        .set('Authorization',token);

        return this._http.post(this.url+'terminal-obtener-por-sucursal',null, {headers:headers});
    }

    /**************************************/

    terminalGestion(item: Terminal,token:string): Observable<any>{
        let params = JSON.stringify(item);
        let headers = new HttpHeaders().set('Content-Type','application/json')
                                       .set('Authorization',token);

        if(item.ID==0){
            return this._http.post(this.url+'terminal-agregar',params, {headers:headers});
        }
        else{
            return this._http.put(this.url+'terminal-modificar',params,{headers:headers});
        }
    }

    terminalBuscarPorId(id:number,token:string):Observable<any>{
        let headers = new HttpHeaders().set('Content-Type','application/json')
                                       .set('Authorization',token);

        return this._http.post(this.url+'terminal-obtener-id/'+id,{headers:headers});
    }

    terminalBuscarTodos():Observable<any>{
        let headers = new HttpHeaders().set('Content-Type','application/json');

        return this._http.get(this.url+'terminal-obtener-todos',{headers:headers});
    }

    obtenerActivas(ID_SUCURSAL:number,token:string):Observable<any>{
        let headers = new HttpHeaders().set('Content-Type','application/json')
                                       .set('Authorization',token);

        //let params = JSON.stringify({ID_SUCURSAL:ID_SUCURSAL});

        return this._http.get(this.url+'terminal-obtener-activas/' + ID_SUCURSAL,{headers:headers});
    }
}